'use strict';
import { observable, action } from 'mobx';
import { fetch } from '@/lib/fetchAPI';
import globalStore from '../Global';

class AppFileStore {
  @observable appListArr = [];
  @observable appModal = false;
  @observable addAppLoading = false;

  loadAppList() {
    fetch(`/api/app`, { method: 'GET' }, json => {
      this.appListArr = json || [];
    });
  }
  @action.bound
  uploadAppFile(id, data) {
    globalStore.loadingStatus = true;
    globalStore.loadingTip = '正在上传中...';
    fetch(
      `/api/app/file?app_id=${id}`,
      {
        method: 'POST',
        body: data
      },
      json => {
        this.loadAppList();
        globalStore.loadingStatus = false;
        globalStore.loadingTip = '';
      }
    );
  }
  addApp(data) {
    globalStore.loadingStatus = true;
    globalStore.loadingTip = '正在上传中...';
    fetch(
      `/api/app`,
      {
        method: 'POST',
        body: data
      },
      json => {
        this.loadAppList();
        this.appModal = false;
        globalStore.loadingStatus = false;
        globalStore.loadingTip = '';
      }
    );
  }
  deleteApp(id) {
    fetch(`/api/app?app_id=${id}`, { method: 'DELETE' }, json => {
      this.loadAppList();
    });
  }
  toggleModal(isShow) {
    this.appModal = isShow;
  }
}
export default new AppFileStore();



// WEBPACK FOOTER //
// ./src/store/AppFile/AppFile.js